<div id="registrationworkerselect">
  <dx-data-grid id="gridContainer"
                [dataSource]="selectedRegistrations"
                keyExpr="workerNumber"
                [showBorders]="costVisible"
                [showColumnHeaders]="costVisible"
                [showColumnLines]="costVisible"
                [wordWrapEnabled]="true"
                [hoverStateEnabled]="true"
                (onEditorPreparing)="onEditorPreparing($event)">
    <dxo-editing mode="cell"
                 [allowUpdating]="true">
    </dxo-editing>
    <dxo-sorting mode="multiple"></dxo-sorting>

    <dxi-column dataField="selected" sortOrder="desc" [allowEditing]="true" [width]="60"></dxi-column>
    <dxi-column dataField="workerDescription" sortOrder="asc" [allowEditing]="false" caption="Dipendente"></dxi-column>

    <dxi-column dataField="cost" [visible]="costVisible" caption="Costo">
      <dxo-lookup [dataSource]="getFilteredCostsAll"
                  valueExpr="costCode"
                  displayExpr="costDescription">
      </dxo-lookup>
    </dxi-column>

    <dxi-column dataField="workerNumber" [visible]="false" [allowEditing]="false"></dxi-column>
    <dxo-selection mode="single"></dxo-selection>
    <dxo-paging [enabled]="false"></dxo-paging>
    <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>
    <dxo-group-panel [visible]="false"></dxo-group-panel>
    <dxo-toolbar>
      <dxi-item name="searchPanel" location="before"></dxi-item>
    </dxo-toolbar>
  </dx-data-grid>
</div>
